import {fetchJSONByPost} from './index.js'
// 发送注册验证码
// scene 22
export const sendSmsCodeApi = (body) => fetchJSONByPost('/admin-api/system/auth/send-sms-code', body)
// 用户注册
export const smsRegisterApi = (body) => fetchJSONByPost('/admin-api/system/auth/sms-register', body)
// 短信登入
export const smsLoginApi = (body) => fetchJSONByPost('/admin-api/system/auth/sms-login', body)
// 使用密码登录
export const smsPwdLoginApi = (body) => fetchJSONByPost('/admin-api/system/auth/sms-password-login', body)
// 刷新令牌
export const refreshTokenApi = (params) => fetchJSONByPost('/admin-api/system/auth/refresh-token', null, {params})
// 注册货代或合作伙伴
export const registerCargoApi = (body) => fetchJSONByPost('/admin-api/ins/company/cargo/register', body)
// 帐号密码登入
export const pwdLoginApi = (body) => fetchJSONByPost('/admin-api/system/auth/login', body)
// 发送语音验证码
export const sendVoiceCodeApi = (body) => fetchJSONByPost('/admin-api/system/auth/send-voice-code', body)
// 重置密码
export const resetPwdApi = (body) => fetchJSONByPost('/admin-api/system/auth/reset-password', body)